import { CardPointeRpaModuleName } from './cardpointe/cardpointe-rpa-module-names';
import { CloverRpaModuleName } from './clover/clover-rpa-module-names';
import { ValorRpaModuleName } from './valor/valor-rpa-module-names';

export const IpgRpaModuleName = {
    ...CardPointeRpaModuleName,
    ...CloverRpaModuleName,
    ...ValorRpaModuleName,
} as const;

export type IpgRpaModuleName = (typeof IpgRpaModuleName)[keyof typeof IpgRpaModuleName];

export const RetiredIpgRpaModuleNames = [ValorRpaModuleName.VALORPAYTECH_WORKFLOWS] as const;
